import http from '../../http';
import { SERVER_URL } from '../../config';

export const getPostCategoryListData = (params) => http.get(`${SERVER_URL}/api-main/v1/blog/category`, {params : { ...params }});